The opaque cursor to the event in the stream.

This can be used as a subsequent pagination argument.
